import React from 'react';
import { Text, View, StyleSheet } from 'react-native';
import {
  Button,
  Dialog,
  Portal,
  Text as PaperText,
  useTheme,
} from 'react-native-paper';

interface ConfirmDeleteDialogProps {
  visible: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  itemSummary?: string; // Optional summary of the item being deleted
  loading?: boolean;
}

const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({
  visible,
  onDismiss,
  onConfirm,
  title,
  message,
  itemSummary,
  loading = false,
}) => {
  const theme = useTheme();

  return (
    <Portal>
      <Dialog visible={visible} onDismiss={onDismiss}>
        <Dialog.Icon icon="delete-alert" />
        <Dialog.Title>{title}</Dialog.Title>
        <Dialog.Content>
          <PaperText variant="bodyMedium">{message}</PaperText>
          {itemSummary && (
            <View style={[styles.itemSummary, { backgroundColor: theme.colors.elevation.level3 }]}>
              <Text
                style={[
                  styles.itemSummaryText,
                  { color: theme.colors.onSurfaceVariant },
                ]}
              >
                {itemSummary}
              </Text>
            </View>
          )}
        </Dialog.Content>
        <Dialog.Actions>
          <Button onPress={onDismiss} disabled={loading}>
            Cancel
          </Button>
          <Button
            mode="contained"
            onPress={onConfirm}
            loading={loading}
            disabled={loading}
            buttonColor={theme.colors.error}
            testID="confirm-delete-button"
          >
            Delete
          </Button>
        </Dialog.Actions>
      </Dialog>
    </Portal>
  );
};

const styles = StyleSheet.create({
  itemSummary: {
    marginTop: 12,
    padding: 12,
    borderRadius: 6,
  },
  itemSummaryText: {
    fontFamily: 'Inter-Medium',
    fontSize: 14,
  },
});

export default ConfirmDeleteDialog;
